import { Dispatch, SetStateAction, useState } from "react";
import { Card } from "../../../components/Card";
import { UserTable } from "../components/UserTable";
import { Button } from "../../../components/Button";
import { useQuery } from "@tanstack/react-query";
import { UserFormModal } from "../components/UserFormModal";
import { api } from "../../../services/api";
import { Roles } from "./components/Roles";
import { LicenseBox } from "./components/LicenseBox";

export function Licenses() {
  const [editUser, setEditUser] = useState<any>(null);

  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const handleAddUser = () => {
    setIsAddUserModalOpen(true);
  };

  const {
    data: usersData,
    isLoading: isLoadingUsers,
    refetch,
  } = useQuery({
    queryKey: [`search-users`],
    queryFn: () => api.searchUsers(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleEditUser = (user: any) => {
    setEditUser(user);
    setIsAddUserModalOpen(true);
  };

  const users = usersData?.users || [];

  const purchased = 100;
  const active = 32;
  const inactive = 68;

  const valuePercentage = (value: number) => {
    return (value / purchased) * 100;
  };
  return (
    <>
      <Card>
        <div className="md:mb-5 flex items-center justify-between">
          <div>
            <div className="text-text-primary text-2xl font-bold">Licenses and Team</div>
          </div>
          <Button
            variant="primary"
            className="!py-3 !rounded-full"
            onClick={handleAddUser}
          >
            Manage Licenses
          </Button>
        </div>
        <div>
            <div className="text-black text-base font-normal mb-[18px]">User Licenses</div>
            <div className="flex items-center lg:gap-20 gap-10">
                <div className="flex flex-col gap-2">
                    <span className="text-black text-[35px] font-medium">32</span>
                    <span className="text-[#15803D] text-sm font-medium">Active</span>
                </div>

                <div className="flex flex-col gap-2">
                    <span className="text-black text-[35px] font-medium">68</span>
                    <span className="text-[#DC2626] text-sm font-medium">Inactive</span>
                </div>

                <div className="flex flex-col gap-2">
                    <span className="text-black text-[35px] font-medium">100</span>
                    <span className="text-black text-sm font-medium">Purchased</span>
                </div>
            </div>
        <div
          className={` my-8 flex-1 flex-1 h-[9px] overflow-hidden rounded-full bg-gray-500`}
        >
          <div
            className={`h-[9px] rounded-full bg-[#14AE5C]`}
            style={{
              width: `${valuePercentage(active) || 0}%`,
            }}
          />
        </div>
        </div>
        <div className="flex gap-4 items-stretch">
            <Roles />
            <LicenseBox />
        </div>
      </Card>
      <UserFormModal
        isOpen={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        user={editUser}
        onSuccess={() => {
          setIsAddUserModalOpen(false);
          refetch();
        }}
      />
    </>
  );
}
